import { externalFramerTrackedLocaleUrl } from '@marketplace/helpers/url.js'
export const FOOTER_COLUMNS = {
    column1: [
        {
            path: '/page/about-us',
            label: 'nav.about_us',
        },
        {
            path: 'https://careers.orderchamp.com/',
            label: 'nav.careers',
            direct: true,
        },
        {
            path: 'https://blog.orderchamp.com/',
            label: 'nav.footer.blog',
            direct: true,
        },
        {
            path: '/page/press',
            label: 'nav.footer.press',
        },
    ],
    column2: [
        {
            path: '/page/faq',
            label: 'nav.footer.how_it_works',
        },
        {
            path: '/brand-directory',
            label: 'nav.brand_directory',
        },
        {
            path: '/retailers',
            label: 'nav.buy-on-orderchamp',
        },
        {
            path: '/brands',
            label: 'nav.sell-on-orderchamp',
        },
        {
            path: '/page/buy-now-pay-later',
            label: 'nav.buy_now',
        },
        {
            path: '/page/what-is-wholesale',
            label: 'nav.wholesale',
            canView: ['isGuest'],
        },
    ],
    column3: [
        {
            path: '/page/plus',
            label: 'nav.footer.orderchamp_plus',
            canView: ['isOCPlus'],
        },
        {
            path: 'https://support.orderchamp.com/hc/articles/21061438616081',
            label: 'nav.footer.orderchamp_plus',
            canView: ['isGuest'],
            direct: true,
        },
        {
            path: '/dropshipping/{locale}?utm_source=marketplace&utm_medium=platform&utm_campaign=retailer_ds_footer',
            label: 'nav.footer.dropshipping_retailers',
            locales: { de: 'de', nl: 'nl', fr: 'fr' },
            direct: true,
            canView: ['retailer', 'supplier', 'isGuest'],
        },
        {
            path: `/dropshipping/{locale}/brands?utm_source=platform&utm_medium=marketplace&utm_campaign=brands_ds_footer`,
            label: 'nav.footer.dropshipping_brands',
            locales: { de: 'de-de', nl: 'nl-nl', fr: 'fr-fr' },
            direct: true,
            canView: ['retailer', 'supplier', 'isGuest'],
        },
        {
            path: externalFramerTrackedLocaleUrl(
                'https://www.orderchamp.cloud'
            ),
            label: 'nav.footer.orderchamp_cloud',
            direct: true,
            canView: ['retailer', 'supplier', 'isGuest'],
        },
    ],
    column4: [
        {
            path: 'https://support.orderchamp.com',
            label: 'nav.footer.help_center',
            direct: true,
        },
        {
            path: 'https://support.orderchamp.com/hc/requests/new',
            label: 'nav.footer.contact_us',
            icon: 'far fa-envelope',
            direct: true,
        },
    ],
}
